import { render, staticRenderFns } from "./ClimateIndicators.vue?vue&type=template&id=ce872e8e&scoped=true"
import script from "./ClimateIndicators.vue?vue&type=script&lang=js"
export * from "./ClimateIndicators.vue?vue&type=script&lang=js"
import style0 from "./ClimateIndicators.vue?vue&type=style&index=0&id=ce872e8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce872e8e",
  null
  
)

export default component.exports